// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiPlan {
    static getAttributeTypeMap() {
        return MedicalBiPlan.attributeTypeMap;
    }
}
MedicalBiPlan.discriminator = undefined;
MedicalBiPlan.additionalProperties = false;
MedicalBiPlan.attributeTypeMap = [
    {
        "name": "gracePeriod",
        "baseName": "gracePeriod",
        "type": "string"
    },
    {
        "name": "isSet",
        "baseName": "isSet",
        "type": "boolean"
    },
    {
        "name": "paidThroughDate",
        "baseName": "paidThroughDate",
        "type": "Date"
    },
];
//# sourceMappingURL=medicalBiPlan.js.map